import viewTable from './viewTable.container';

export default viewTable;
